<template>
  <div class="card">
    <div class="card-body">
      <!-- search input -->
      <div class="custom-search d-flex justify-content-end">
        <div class="mr-auto">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            @click="$router.push({name: 'schedule-page', params: {id: 'new'}})"
          >
            Новое расписание
          </b-button>
        </div>
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1">Поиск</label>
            <b-form-input
              v-model="searchTerm"
              placeholder="Search"
              type="text"
              class="d-inline-block"
              @input="onSearch"
            />
          </div>
        </b-form-group>
      </div>

      <!-- table -->
      <vue-good-table
        :columns="columns"
        :rows="rows"
        :select-options="{
          enabled: true,
          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true, // disable the select info panel on top
          selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
        }"
        @on-sort-change="onSortChange"
      >
        <template
          slot="table-row"
          slot-scope="props"
        >
          <span v-if="props.column.field === 'workout'">
            {{ props.row.workout && props.row.workout.type ? props.row.workout.type : 'Тип тренировки не указан' }}
          </span>

          <span v-else-if="props.column.field === 'weekday'">
            {{ props.row.weekday ? props.row.weekday : 'День не указан' }}
          </span>

          <span v-else-if="props.column.field === 'createdAt'">
            <span>
              {{ formatDate(props.row) }}
            </span>
          </span>

          <span v-else-if="props.column.field === 'startDate'">
            {{ props.row.startDate ? props.row.startDate : 'Время не указано' }}
          </span>

          <!-- Column: Action -->
          <span v-else-if="props.column.field === 'action'">
            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>

                <router-link
                  :to="{name: 'schedule-page', params:{ id: props.row.id }}"
                  class="edit-button"
                >
                  <feather-icon
                    icon="Edit2Icon"
                    class="mr-50"
                  />
                  <span>Редактировать</span>
                </router-link>

                <b-dropdown-item
                  v-b-modal.modal-primary
                  variant="outline-primary"
                  @click="clubToDelete=props.row.id"
                >
                  <feather-icon
                    icon="TrashIcon"
                    class="mr-50"
                  />
                  <span>Удалить</span>
                </b-dropdown-item>
              </b-dropdown>
            </span>
          </span>

          <!-- Column: Common -->
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <infinite-loading
        ref="infloader"
        spinner="bubbles"
        @infinite="infiniteScroll"
      >
        <div slot="no-more" />
        <div slot="no-results" />
      </infinite-loading>
    </div>
    <div>
      <!-- button trigger -->
      <div class="demo-inline-spacing" />

      <!-- modal -->
      <b-modal
        id="modal-primary"
        v-model="modalIsOpen"
        ok-only
        ok-title="Отмена"
        modal-class="modal-primary"
        centered
        title="Primary Modal"
      >
        <div>Вы действительно хотите удалить расписание?</div>
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          class="mt-1"
          variant="primary"
          @click="deleteItem(clubToDelete)"
        >
          Удалить
        </b-button>
      </b-modal>

    </div>
  </div>
</template>

<script>
import {
  BDropdown,
  BDropdownItem,
  BFormGroup,
  BFormInput,
  BButton,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import InfiniteLoading from 'vue-infinite-loading'
import crud_module from '../../../libs/crud_module'

const schedules_module = crud_module({
  entity_name: 'schedule',
})

export default {
  components: {
    VueGoodTable,
    BFormGroup,
    BFormInput,
    BDropdown,
    BDropdownItem,
    BButton,
    InfiniteLoading,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      skipCount: 0,
      maxResultCount: 9,
      modalIsOpen: false,
      clubToDelete: null,
      columns: [
        {
          label: 'ID',
          field: 'id',
          sortable: true,
        },
        {
          label: 'Тип тренировки',
          field: 'workout',
          sortable: false,
        },
        {
          label: 'Адрес проведения',
          field: 'address',
          sortable: true,
        },
        {
          label: 'День проведения',
          field: 'weekday',
          sortable: true,
        },
        {
          label: 'Время проведения',
          field: 'startDate',
          sortable: true,
        },
        {
          label: 'Дата создания',
          field: 'createdAt',
          sortable: true,
        },
        {
          label: 'Действие',
          field: 'action',
          sortable: false,
        },
      ],
      rows: [],
      searchTerm: '',
      sorting: null,
      debounce: null,
    }
  },
  methods: {
    async infiniteScroll($state) {
      const payload = this.buildPayload()
      await schedules_module.fetchItems(payload)
        .then(res => {
          if (res.data.rows.length > 0) {
            this.rows.push(...res.data.rows)
            this.skipCount += this.maxResultCount
            $state.loaded()
          } else {
            $state.complete()
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    async deleteItem(id) {
      await schedules_module.deleteItem(id)
      this.updateData()
      this.modalIsOpen = false
    },
    buildPayload() {
      const payload = {
        skipCount: this.skipCount,
        maxResultCount: this.maxResultCount,
      }

      if (this.searchTerm) payload.filterText = this.searchTerm
      if (this.sorting) payload.sorting = this.sorting

      return payload
    },
    onSearch() {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => this.updateData(), 400)
    },
    onSortChange(params) {
      const sort = params[0]
      const fields = {
        id: 'id',
        address: 'address',
        weekday: 'weekday',
        startDate: 'startDate',
        createdAt: 'createdAt',
      }

      this.sorting = sort && sort.type !== 'none' && fields[sort.field]
        ? `${fields[sort.field]} ${sort.type}`
        : null
      this.updateData()
    },
    updateData() {
      this.rows = []
      this.skipCount = 0
      this.$refs.infloader.stateChanger.reset()
    },
    formatDate(rowObj) {
      const newDate = new Date(rowObj.createdAt)
      const options = { year: 'numeric', month: 'long', day: 'numeric' }
      const newStr = newDate.toLocaleDateString('ru', options)
      return newStr
    },
  },
}
</script>

<style lang="scss">
.message {
   font-size: 12px;
   font-weight: 600;
   color: red;
}
  .edit-button{
    padding: 0.65rem 1.28rem;
    display: flex;
    align-items: center;

    &:hover{
      background-color: rgba(115, 103, 240, 0.12);
    }
  }
  @import '@core/scss/vue/libs/vue-good-table.scss';
</style>
